import React from 'react';

const DownPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f0f4f8',
        textAlign: 'center',
        color: '#333',
        fontFamily: 'Arial, sans-serif',
        padding: '20px',
      }}
    >
      {/* GIF Animation */}
      <img
        src="/images/Downpage.gif"
        alt="Service Unavailable Animation"
        style={{ width: '800px', height: '400px', marginBottom: '20px' }}
      />

      {/* Spinner Animation */}
      <div
        style={{
          border: '12px solid #e0e0e0',
          borderRadius: '50%',
          borderTop: '12px solid #007bff',
          width: '100px',
          height: '100px',
          animation: 'spin 1.5s linear infinite',
          marginBottom: '30px',
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      {/* Content */}
      <h1 style={{ fontSize: '3rem', color: '#d9534f', marginBottom: '20px' }}>
        Service Unavailable
      </h1>
      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        Our service is currently unavailable. We are working hard to restore it as soon as possible.
      </p>
      <p style={{ fontSize: '1.2rem', marginBottom: '10px' }}>
        If you need immediate assistance, please contact us at:
      </p>
      <a
        href="mailto:support@janneyai.com"
        style={{
          fontSize: '1.2rem',
          color: '#007bff',
          textDecoration: 'none',
          marginBottom: '30px',
        }}
      >
        support@janneyai.com
      </a>
    </div>
  );
};

export default DownPage;
